<footer class="w-full">
    <div class="footer">
        <div class="flex flex-col-reverse lg:h-77 lg:flex-row">
            <div
                class="bg-primary flex w-full shrink flex-col gap-y-8 px-4 py-6 lg:w-1/2 lg:flex-row lg:gap-y-0 lg:px-8 lg:py-12"
            >
                <div class="flex flex-1 flex-row items-center justify-between lg:flex-col lg:justify-center lg:gap-y-8">
                    <div class="h-auto w-24">
                        <img alt="Packbo" ngSrc="assets/images/packbo-logo-white.svg" width="96" height="32" />
                    </div>
                    <div class="flex gap-x-6">
                        @for (item of footerSocialLinks(); track item?.id) {
                            <a class="text-body-small text-white" [href]="item?.url">
                                <img
                                    alt="Packbo"
                                    class="size-6"
                                    [ngSrc]="item?.icon | getDirectusImage"
                                    width="24"
                                    height="24"
                                />
                            </a>
                        }
                    </div>
                </div>
                <div class="flex flex-1 flex-col gap-y-4">
                    @for (item of footerNavigationItems(); track item?.id) {
                        <a class="text-body-small text-white" [href]="item?.page_ref | pathFromItem: 'page'">
                            {{ item?.translations_refs | getTranslation: "title" }}
                        </a>
                    }
                </div>
            </div>
            <div class="bg-secondary-20 flex w-full shrink lg:relative lg:w-1/2">
                <div
                    class="flex flex-1 flex-col items-center justify-start gap-y-8 px-4 py-6 lg:h-full lg:items-start lg:justify-center lg:px-8 lg:py-0"
                >
                    <p class="text-headline-small max-w-150 shrink text-left text-white">
                        {{ footerDefinition()?.translations_refs | getTranslation: "newsletter_title" }}
                    </p>
                    <form
                        class="text-body-small flex w-full max-w-90 flex-col items-center justify-start gap-x-3 gap-y-3 lg:w-115 lg:flex-row"
                        [formGroup]="newsletterForm"
                        (ngSubmit)="onNewsletterSubmit()"
                    >
                        <input
                            class="placeholder:text-neutral-variant-60 w-full rounded-md bg-white px-6 py-3 outline-1 -outline-offset-1 outline-white focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-500"
                            formControlName="email"
                            id="newsletter-email"
                            placeholder="john.doe@example.com"
                            type="email"
                            [class.border-red-500]="
                                newsletterForm.get('email')?.invalid && newsletterForm.get('email')?.touched
                            "
                        />
                        <button
                            class="bg-primary w-full rounded-md px-6 py-3 text-white disabled:cursor-not-allowed disabled:opacity-50 lg:w-auto"
                            type="submit"
                            [disabled]="isSubmitting || newsletterForm.invalid"
                        >
                            {{ isSubmitting ? "Subscribing..." : ("footer.newsletter_button" | transloco) }}
                        </button>
                    </form>
                    @if (submitMessage()) {
                        <p class="text-body-small mt-2 text-white">
                            {{ submitMessage() | transloco }}
                        </p>
                    }
                </div>
                <div class="absolute top-8.5 right-17.5 hidden lg:block">
                    <img
                        alt="Packbo"
                        class="opacity-10"
                        ngSrc="assets/images/packbo-outline.svg"
                        width="100"
                        height="100"
                    />
                </div>
            </div>
        </div>
        <div
            class="bg-primary-30 text-label-large flex flex-col-reverse items-center justify-center gap-y-2 py-3 text-white lg:h-16 lg:flex-row lg:gap-x-8"
        >
            <p class="shrink grow-0 text-center">
                {{ copyrightDefinition()?.translations_refs | getTranslation: "copyright" }}
            </p>

            <span class="w-full max-w-90 flex-none border-t border-white/20 lg:hidden"></span>
            <div class="flex shrink grow-0 flex-col items-center justify-center gap-x-8 gap-y-2 lg:flex-row">
                @for (item of copyrightNavigationItems(); track item?.id) {
                    <span class="hidden shrink-0 grow-0 lg:block">|</span>
                    @if (item?.page_ref) {
                        <a class="shrink grow-0 text-center" [href]="item?.page_ref | pathFromItem: 'page'">
                            {{ item?.translations_refs | getTranslation: "title" }}
                        </a>
                    } @else if (item?.url) {
                        <a class="shrink grow-0 text-center" [href]="item?.url">
                            {{ item?.translations_refs | getTranslation: "title" }}
                        </a>
                    }
                }
            </div>
        </div>
    </div>
</footer>
